// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__0Vayx","title":"NotFound_title__I8tLE","back":"NotFound_back__SwLJg"};